import { render, staticRenderFns } from "./Livigno.vue?vue&type=template&id=55fd9735&scoped=true&"
import script from "./Livigno.vue?vue&type=script&lang=js&"
export * from "./Livigno.vue?vue&type=script&lang=js&"
import style0 from "./Livigno.vue?vue&type=style&index=0&id=55fd9735&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fd9735",
  null
  
)

export default component.exports